import Model from '@/models/Model'
import { EventBus } from '@/app'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'payments',
            name: 'payment',
            class: 'Modules\\Ecommerce\\Entities\\Payment',
            forms: {}
        }
    },

    methods: {
        loadPayableByKey(payable_key) {
            return axios({
                method: 'get',
                url: route('api.payments.loadPayableByKey', payable_key)
            })
            .then(response => response.data.data)
        },

        allPayables() {
            return axios({
                method: 'get',
                url: route('api.payments.all.payables')
            })
            .then(
                response => response.data.data.filter(p => p.is_payable.success)
            )
        },

        addForm(payment_method_slug, component) {
            this.forms[payment_method_slug] = component

            return this
        },

        getForm(payment_method_slug) {
            return this.forms[payment_method_slug]
        }
    },

    created() {
        this.addForm('local.deposit.web', 'local-deposit-web-payment-form')

        this.$Util.formattedClassName['Modules\\Ecommerce\\Entities\\Payment'] = 'Pago'
        this.$Util.tableNameByClassName['Modules\\Ecommerce\\Entities\\Payment'] = 'payments'
        this.$Util.classNameByTableName['payments'] = 'Modules\\Ecommerce\\Entities\\Payment'

        this.$Util.formattedStatus = {
            ...this.$Util.formattedStatus,
            ...{
                'payment.promise': 'No pagado',
                'payment.created': 'En revisión',
                'payment.accepted': 'Aceptado',
                'payment.rejected': 'Rechazado',
                'payment.canceling': 'Cancelándose',
                'payment.cancelled': 'Cancelado',
                'payment.refunded': 'Devuelto',
                'payment.disputed': 'En disputa',
                'payment.chargeback': 'Contracargo'
            }	
        }
    }
}